export const defaultFilters = () => ({
  dateFrom: '',
  dateTo: '',
  user: [],
  entity: '',
  entities: [],
  updates: 'all',
  entityId: null,
  action: '',
  offerPartners: [],
  properties: [],
  sortBy: ['createdAt'],
  sortDesc: [true],
})

const toArray = v => (v == null ? undefined : Array.isArray(v) ? v : [v])
const toBoolArray = v => {
  const arr = toArray(v)
  return arr ? arr.map(d => d === 'true' || d === true) : undefined
}

export function buildQueryFromRoute(routeQuery) {
  const { page, limit, sortBy, sortDesc, updates, ...rest } = routeQuery
  return {
    ...rest,
    updates: updates || 'all',
    pagination: {
      page: parseInt(page) || 1,
      limit: parseInt(limit) || 20,
    },
    ...(sortBy !== undefined && { sortBy: toArray(sortBy) }),
    ...(sortDesc !== undefined && { sortDesc: toBoolArray(sortDesc) }),
  }
}

export function cleanQuery(query) {
  return Object.fromEntries(
    Object.entries(query).filter(([, v]) => {
      if (v == null || v === '') return false
      return !(Array.isArray(v) && !v.length)
    })
  )
}
